import Enum from "../../../enums/Enum";

const EnumCoPayUnit = new Enum({
    PERCENTAGE: "%",
    AED: "AED",
    // KWD: "KWD", // TODO: Enable this remove AED in KUWAIT
});

export default EnumCoPayUnit;
